<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-click-outside="closeModal">
          <div class="modal-body text-center">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  methods: {
    closeModal: function(){
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.modal-enter {
  opacity: 0;
}

.modal-content iframe{
  margin: 0 auto;
  display: block;
}

.modal-body {
  padding: 5px;
}
.modal-footer {
  padding: 0;
}

.modal-container {
  max-width: 700px;
  overflow-y: auto;
}

.modal-body {
  overflow-y: auto;
}

.modal-body.text-center{
  text-align: center;
}
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
